import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AfficheFavorite = async (idClient) => {
    return await axios.get(`${BASE_URL}/api/client/afficherFavorite/${idClient}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}


const SuprimerFavorite = async (data) => {
    return await axios.post(`${BASE_URL}/api/client/ajouteFavorite`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
        }
    });
}


export { AfficheFavorite, SuprimerFavorite}